export type BottleneckMessage = {
    type: string
    label: string
    impact: number
    description?: string
    args?: {
        [key: string]: string | string[] | number | { [call: string]: number | { ct: number; wt: number; perc?: number } }
    }
}

export const bottleneckMessageHasRelatedCalls = (
    args: object,
): args is {
    relatedCalls: { [fn: string]: number }
} => 'relatedCalls' in args
